module.exports = __webpack_public_path__ + "img/kp.93ba4cfa.svg";